import { Suspense } from 'react'

import { createFileRoute, Outlet } from '@tanstack/react-router'

import { Shell } from '@/shared/ui/Shell'
import { QueryParamToast } from '@/shared/ui/QueryParamToast'

export const Route = createFileRoute('/_authenticated/_main')({
  component: MainShellRoute
})

function MainShellRoute() {
  return (
    <Shell>
      <Suspense fallback={null}>
        <QueryParamToast />
      </Suspense>
      <Outlet />
    </Shell>
  )
}
